import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { Edit, Delete, Add } from "@mui/icons-material";
import DataTable from "../../../Table/DataTable";
import SearchFilterBar from "../../../Table/SearchFilterBar";
import PaginationControl from "../../../Table/PaginationControl";
import ActiveSwitch from "../../../ActiveSwitch/ActiveSwitch";
import toast from 'react-hot-toast';
import { getAdminBrands, toggleBrandActive, deleteBrand } from "../../../../actions/brandActions";
import { clearBrandDeleted, clearError, clearBrandUpdated } from '../../../../slices/brandSlice';
import ConfirmToast from "../components/ConfirmToast";
import { useDispatch, useSelector } from "react-redux";

const Brands = () => {
    const { brands = [], loading = true, error: brandsError } = useSelector(state => state.brandsState);
    const { isBrandDeleted , isBrandUpdated, error } = useSelector(state => state.brandState);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [filter, setFilter] = useState("All");
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const perPage = 5;

    useEffect(() => {
        dispatch(getAdminBrands())
    }, [dispatch]);

    useEffect(() => {
        if (isBrandDeleted) {
            toast.success("Brand deleted successfully!");
            dispatch(clearBrandDeleted());
            dispatch(getAdminBrands());
        }
        else if (isBrandUpdated) {
            toast.success("Status Updated successfully!");
            dispatch(clearBrandUpdated());
            dispatch(getAdminBrands());
        }
    }, [isBrandDeleted, isBrandUpdated, dispatch]);

    useEffect(() => {
        if (error) {
            toast.error(error);
            dispatch(clearError());
        }
        else if (brandsError) {
            toast.error(brandsError);
            dispatch(clearError());
        }
    }, [error, brandsError, dispatch]);

    const toggleStatus = (id) => {
        dispatch(toggleBrandActive(id));
    };

    const handleDelete = (id) => {
        ConfirmToast({
            message: "Are you sure you want to delete this sub category?",
            onConfirm: () => dispatch( deleteBrand(id)),
        });
    };

    const filtered = brands.filter((p) => {
        const matchesSearch = p.name.toLowerCase().includes(search.toLowerCase());
        const matchesFilter =
            filter === "All" ||
            (filter === "Active" && p.isActive) ||
            (filter === "Inactive" && !p.isActive);
        return matchesSearch && matchesFilter;
    });

    // Pagination
    const totalPages = Math.ceil(filtered.length / perPage);
    const paginated = filtered.slice((page - 1) * perPage, page * perPage);

    const handleEdit = (id) => {
        navigate(`/admin/brand/${id}`);
    };

    const columns = ["#", "Image", "Name", "Status", "Actions"];

    const renderRow = (p, i) => (
        <tr key={p._id}>
            <td>{(page - 1) * perPage + i + 1}</td>
            <td>
                <img
                    src={p.image}
                    alt={p.name}
                    className="cat-img"
                />
            </td>
            <td>{p.name}</td>
            <td>
                <ActiveSwitch
                    checked={p.isActive}
                    onChange={() => toggleStatus(p._id)}
                />
            </td>
            <td>
                <div className="d-flex justify-content-center gap-2">
                    <Button size="sm" variant="warning" onClick={() => handleEdit(p._id)}>
                        <Edit fontSize="small" />
                    </Button>
                    <Button size="sm" variant="danger">
                        <Delete fontSize="small" onClick={() => handleDelete(p._id)} />
                    </Button>
                </div>
            </td>
        </tr>
    );

    return (
        <div className="container-fluid p-3">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h4 className="fw-bold mb-4">Brand Management</h4>
                <Button
                    variant="success"
                    onClick={() => navigate("/admin/brand/add")}
                >
                    <Add className="me-2" /> Add New
                </Button>
            </div>

            <SearchFilterBar
                searchTerm={search}
                setSearchTerm={setSearch}
                placeholder="Search slider..."
                filterValue={filter}
                setFilterValue={setFilter}
                filterOptions={["Active", "Inactive"]}
            />

            <DataTable columns={columns} data={paginated} renderRow={renderRow} />
            <PaginationControl
                totalPages={totalPages}
                currentPage={page}
                onPageChange={setPage}
            />

        </div>
    );
};

export default Brands;
